import React from 'react';
import { makeStyles } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import { MachinePlannedStop, QualityOutOfSpec, MachineUnPlannedStop, MachineStart, ScissorScrap, ScissorProduction, UnKnownQualityCheckType } from '../../Config/constants';
import { toDateFormatWithoutT } from '../../Helpers/dateHelper';

export default function MessageContent(props) {
    const classes = useStyles();

    let iconColor = ""
    let icon = <React.Fragment></React.Fragment>
    let borderLeft = ""

    //let metaData = JSON.parse(props.message.metaData).find(y => y.MetaDataType === 1).MetaData[0]

    switch (props.message.notificationTypeId) {
        case MachinePlannedStop:
            iconColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            borderLeft = "solid 8px rgb(92,201,88,0.2)"
            break;
        case MachineUnPlannedStop:
            iconColor = "#D84949";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft = "solid 8px rgb(216,73,73,0.2)"
            break;
        case MachineStart:
            iconColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            borderLeft = "solid 8px rgb(92,201,88,0.2)"
            break;
        case QualityOutOfSpec:
            iconColor = "#D84949";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft = "solid 8px rgb(216,73,73,0.2)"
            break;
        case ScissorScrap:
            iconColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            borderLeft = "solid 8px rgb(92,201,88,0.2)"
            break;
        case ScissorProduction:
            iconColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            borderLeft = "solid 8px rgb(92,201,88,0.2)"
            break;
        case UnKnownQualityCheckType:
            iconColor = "#D84949";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft = "solid 8px rgb(216,73,73,0.2)"
            break;
        default:;

    }

    return (
        <div className={classes.messageContainer}>
            <div className={classes.dateTime}>
                {toDateFormatWithoutT(props.message.insertedOn)}
            </div>
            <div className={classes.message} style={{ borderLeft: borderLeft, backgroundColor: props.backgroundColor }}>
                <div className={classes.icon} style={{ color: iconColor, paddingTop: props.iconPadding }}>{icon}</div>
                <div className={classes.text} style={{ width: props.textWidth }}>{props.message.message}</div>
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    icon: {
        float: "left",
        marginRight: "20px"
    },
    text: {
        float: "left",
        paddingTop: "3px"
    },
    message: {
        width: "100%",
        borderRadius: "6px",
        paddingTop: "10px",
        boxSizing: "border-box",
        paddingLeft: "10px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#020100',
        overflow: "auto",
        paddingBottom: "10px",
        minHeight: "65px"
    },
    dateTime: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginTop: "10px"
    },
}));